import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: { defaultMessage: 'Health factor' },
  description: {
    defaultMessage:
      'The health factor represents the safety of your loan derived from the proportion of collateral versus amount borrowed. Keep it above 1 to avoid liquidation.',
  },
});
